import Config from "../../../Config";
import Occupancy from "../channels/Occupancy";
import MarketPrice from "../channels/MarketPrice";
import MarketPrice1 from "../channels/MarketPrice2";
import MarketPrice2 from "../channels/MarketPrice1";
import RatePrice from "../channels/RatePrice";
import MarketPriceMuted from "../channels/MarketPriceMuted";
import RatePriceLowest from "../channels/RatePriceLowest";
import Temperature from "../channels/Temperature";

let channelTemplates = {

    /**Analysis day*/
    "oc": Occupancy,
    "ocs": Occupancy,
    "ocd": Occupancy,
    "oct": Occupancy,
    "mps": MarketPrice,
    "mpd": MarketPrice,
    "mpt": MarketPrice,
    "rps": RatePrice,
    "rpd": RatePrice,
    "rpld": RatePriceLowest,
    "rpls": RatePriceLowest,
    "rplt": RatePriceLowest,
    "rpt": RatePrice,
    "mp1": MarketPrice1,
    "mp2": MarketPrice2,
    "mpm": MarketPriceMuted,
    "mt": Temperature
};

let style = {
    "line": {
        pointStyle: "circle",
        pointBorderWidth: 2,
        borderWidth: 1,
        fill: true,
        lineTension: 0,
        animation: {
            duration: 0,
            easing: "linear"
        }
    },
    "bar": {
        fill: true,
        borderWidth: 2,
        // maxBarThickness: 20,
        scaleBeginAtZero: false
    }
};

export default class ChartDataParser {
    static parse(data, channels, labelPrefix = "", noFill = false, ret = null, indexed = false, indexLabels = null) {
        ret = ret || {
            labels: [],
            datasets: []
        };

        /**protection for doubled labels*/
        if (!ret.hasOwnProperty("labelIndex")) {
            ret.labelIndex = {};
        }

        /**check for bindings to other channels*/
        let bindings = this.getBindings(channels);
        console.log(bindings);

        /**process channels*/
        let channelIndex = channels.split(",");

        let dataSets = {};
        for (let time in data) {
            let d = data[time];

            /**attention: on indexed charts we can not just use push, since labels might already exist*/
            if (!ret.labelIndex.hasOwnProperty(time)) {
                ret.labels.push(time);
                ret.labelIndex[time] = true;
            }

            let i = ret.datasets.length;
            let fill = !noFill;
            let j = 0;
            for (let channel in d) {
                if (!dataSets.hasOwnProperty(channel)) {
                    let template = null;

                    /**is there a binding to another output channel?*/
                    if (bindings.hasOwnProperty(channel) &&
                        undefined !== bindings[channel]) {
                        let bind = bindings[channel];

                        template = Object.assign(channelTemplates[channel], channelTemplates[bind]);

                        console.log('Template: ' + channel + ' > ' + bind  + ' = ' + template.label);

                        /**if new channel has no label, take old one*/
                        if (template.hasOwnProperty("label") === false ||
                            null === template.label) {
                            template.label = channelTemplates[channel].label;
                        }

                    /**is there a mapping from channel to object?*/
                    } else if (channelTemplates.hasOwnProperty(channel)) {
                        console.log("Template: " + channel);
                        template = channelTemplates[channel];
                    }

                    /**channel found*/
                    if (template) {
                        let dataSet = Object.assign({data: []}, template);

                        /**Channel e.g. = ht, search for ht:1233 in channelIndex*/
                        let cKey = null;
                        /**was pushed to other channel?*/
                        let cPushed = false;
                        for (let cI in channelIndex) {
                            cPushed = !!channelIndex[cI].indexOf('>');
                            let cIp = channelIndex[cI].split(":");
                            if (cIp[0] === channel) {
                                cKey = channelIndex[cI];
                            }
                        }

                        /**Now search for the key ht:1233 in Labels*/
                        if (indexLabels && indexLabels.hasOwnProperty(cKey)) {
                            dataSet["label"] = indexLabels[cKey];
                        }

                        /**color palette defined by channel OR if indexed by count*/
                        let col = (template.hasOwnProperty('colorPalette') ? template["colorPalette"] : i);
                        if (true === indexed && false === cPushed) {
                            col = i;
                        }
                        dataSet = this.setColor(dataSet, col, fill);

                        /**area fil*/
                        if (template.fill) {
                            fill = false;
                        }
                        dataSet["channel"] = channel;
                        dataSets[channel] = dataSet;
                        dataSet.label = (labelPrefix.length ? labelPrefix : dataSet.label);

                        ret.datasets.push(dataSet);
                    }
                }

                if (dataSets.hasOwnProperty(channel)) {
                    let dataSet = dataSets[channel];
                    let channelValue = d[channel];

                    /**array of values for scatter*/
                    if (Array.isArray(channelValue)) {
                        for (let v in channelValue) {
                            dataSet.data.push({"x": time, "y": channelValue[v]});
                        }
                    /**simple values, e.g. int, float etc, or objects for plugins which are transformed by channel*/
                    } else {
                        /**transform datapoint by channel*/
                        let v = dataSet.hasOwnProperty("dataTransformCallback") ? dataSet.dataTransformCallback(time, channelValue, dataSets) : channelValue;

                        /**also include null values to include data gaps*/
                        if (dataSet.xAxis.type === "time") {
                            if (null !== v) {
                                dataSet.data.push({"x": moment(time, 'YYYY-MM-DD HH:mm:ss').toDate(), "y": v, "v": channelValue});
                            }
                        } else {
                            if (null !== v) {
                                dataSet.data.push({"x": time, "y": v, "v": channelValue});
                            }
                        }
                    }
                }

                i++;
                j++;
            }
        }

        ret.labels.sort();

        return ret;
    }

    static parseIndexed(data, channels, labels) {
        let ret = {
            labels: [],
            datasets: []
        };

        /**channel:id => label*/
        let i=0;
        /*channelRef = channel:id*/
        let channelRef = channels.split(",");

        /**index = id, root level*/
        for (let index in data) {

            /*channel id string*/
            let cNames = channelRef[i].split(':');
            let cName = cNames[0]+":"+index;

            ChartDataParser.parse(data[index], channels, (labels[cName] || ""), true, ret, true);
            i++;
        }

        this.fixIndexedDatasetValues(ret);

        return ret;
    }

    static fixIndexedDatasetValues(config) {
        if (config.labels.length <= 1) return;
        for (let dataset of config.datasets) {
            if (dataset.data.length > 1) return;
        }

        for (let dataset of config.datasets) {
            if (dataset.data.length > 1) continue;

            let index = dataset.data[0].x;
            let newData = [];

            for (let label of config.labels) {
                if (label !== index) {
                    newData.push({x: label, y: null});
                } else {
                    newData.push(dataset.data[0]);
                }
            }

            dataset.data = newData;
            dataset.stack = "stack1";
        }
    }

    /**
     *
     * @param {object} template
     * @param {number} index
     * @param {boolean} fill
     * @returns {*}
     */
    static setColor(template, index, fill) {
        let color = Config.colorPalette[index % Config.colorPalette.length];

        if (template.type === "line") {
            /*create template based on generic styles*/
            let tpl = Object.assign({}, style["line"]);

            /*copy channel template and overwrite default styles*/
            template = Object.assign(tpl, template);

            if (!template.hasOwnProperty("pointBorderColor")) {
                template.pointBorderColor = color["stroke"];

                if (!template.hasOwnProperty("pointBackgroundColor")) {
                    template.pointBackgroundColor = "#fff";
                }
            }

            if (!template.hasOwnProperty("background")) {
                template.backgroundColor = color["backgroundLight"];
            }

            if (!template.hasOwnProperty("borderColor")) {
                template.borderColor = color["stroke"];
            }
            template.pointHoverBackgroundColor = "white";

        } else if (template.type === "bar") {
            template = Object.assign({}, template, style["bar"]);

            if (!template.hasOwnProperty("fillColor")) {
                template.fillColor = color["backgroundLight"];
            }
            if (!template.hasOwnProperty("strokeColor")) {
                template.strokeColor = color["stroke"];
            }
            if (!template.hasOwnProperty("backgroundColor")) {
                template.backgroundColor = color["backgroundLight"];
            }
            if (!template.hasOwnProperty("borderColor")) {
                template.borderColor = color["stroke"];
            }
            if (!template.hasOwnProperty("highlightFill")) {
                template.highlightFill = color["background"];
            }
            if (!template.hasOwnProperty("highlightStroke")) {
                template.highlightStroke = color["stroke"];
            }
        }

        template.fill = template.fill && fill;

        return template;
    }

    /**
     * Extract output bindings from channels
     * Attention: channels separated by ",", ids separated by ":" and time shift separated by "~" - binding separation by ">"
     *
     * @param channels
     * @returns {{}}
     */
    static getBindings(channels) {
        let bindings = {};

        let arr = channels.split(",");
        for (let i in arr) {
            /*channel is binded to another*/
            if (arr[i].indexOf(">")) {
                /*split channel:id from >binding*/
                let parts = arr[i].split(">");

                /*also: split by id and other extensions*/
                let subpart = parts[0].split(":");

                /*use only channel name without any additions*/
                if (undefined !== parts[1]) {
                    bindings[subpart[0]] = parts[1];
                }
            }
        }
        return bindings;
    }
}



// WEBPACK FOOTER //
// ./src/components/chart/data/ChartDataParser.js